<template>
	<div class="content">
		<table class="table is-fullwidth">
			<thead>
				<tr>
					<th colspan="3">
						<div class="is-flex is-flex-apart">
							<span>Roster</span>
							<Dropdown
								:options="page.rosters"
								:optionText="(option) => option.name"
								:handleSelectedOption="(index, roster) => setSelectedRosterType(roster.type)"
							/>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<template v-for="roster_position in selectedRoster.roster_positions">
					<tr v-for="player in roster_position.players">
						<td>{{ roster_position.position }}</td>
						<td>
							{{ player.name }} - <small>{{ player.team_abbr }}</small>
						</td>
						<td class="has-text-right">{{ player.points }}</td>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>

<script>
import Dropdown from "./Dropdown"

export default {
	props: ["page"],
	components: {
		Dropdown,
	},
	data() {
		return {
			selectedRosterType: "season",
		}
	},
	computed: {
		selectedRoster() {
			return this.page.rosters.find((roster) => roster.type == this.selectedRosterType)
		},
	},
	methods: {
		setSelectedRosterType(rosterType) {
			this.selectedRosterType = rosterType
		},
	},
}
</script>

<style scoped>
thead th .is-flex-apart {
	align-items: center;
}
</style>
